
export function clipAccessLabel(clip) {
	if (!clip || clip.access_type === "free") return null;
	if (clip.access_type === "subscription") return "اشتراکی";
	if (clip.access_type === "credit") return `${clip.credit_cost} اعتبار`;
	return "دسترسی محدود";
}
